/**
 *  Default language file
 *
 *  Deze file wordt gebruikt om tekst te vertalen.
 *  Per regel wordt een stukje van de tekst vertaald.
 *  Alles voor de ':' NIET veranderen, hier wordt de tekst mee vertaald.
 *
 *  Voor elke taal een nieuw bestand maken met de landcode als naam (en.js, nl.js, fr.js en de.js)
 */
import fr from 'vuetify/lib/locale/fr'

export default {
  ...fr,

  // Algemeen
  lang: {
    'English': 'Anglais',
    'Dutch': 'Néerlandais',
    'German': 'Allemand',
    'Français': 'Français',
    'english': 'Anglais',
    'dutch': 'Néerlandais',
    'german': 'Allemand',
    'french': 'Français'
  },

  userInfo: {
    noVendor: "Aucun fournisseur attribué",
  },

  noDataText: '',

  general: {
    name: "Nom",
    user: "Nom du consommateur",
    createdAt: "Créé à",
    createdBy: "Créé par",
    lastSeen: "Vu pour la dernière fois",
    actions: "Actions",
    imei: "Imei",
    frameNumber: "Numéro de cadre",
    odo: "Odo",
    tags: "Mots clés",
    active: "Groupe ciblé",
    maintenance_plan: "Plan de maintenance",
    subscription: "Abonnement",
    business: "Entreprise",
    title: "Titre",
    iccid: "ICCID",
    description: "La description",
    firmware: "Micrologiciel",
    crc: "CRC",
    entity: "Entité",
    type: "Taper",
    color: "Couleur",
    brand: "Marque",
    model: "Modèle",
    engine_brand: "Marque du moteur",
    engine_model: "Modèle de moteur",
    first_name: "Prénom",
    last_name: "Nom de famille",
    address: "Adresse",
    postcode: "Code postal",
    city: "Ville",
    phone: "Téléphoner",
    email: "E-mail",
    additionalInfo: "information additionnelle",
    search: "Chercher",
    total: "Total",
    sub_vendor: {
      name: "Vendeur"
    },
    role: {
      name: "Rôle"
    },
    types: {
      Bike: "Bicyclette",
      eBike: "vélo électrique",
      eCargoBike: "vélo cargo",
      unregistered: 'NON ENREGISTRÉ',
      speedPedelec: "vitesse pedelec",
      eMoped: "e-cyclomoteur",
      moped: "vélomoteur",
      automobile: "voiture",
      other: "autre",
    },
    last_seen_at: "Vu pour la dernière fois",
    save: "enregistrer",
    cancel: "Annuler",
    close: "proche",
    searched: "Aucun résultat correspondant trouvé",
    camera: {
      errorPermission: "Vous devez accorder l'autorisation d'accès à la caméra",
      errorNoCamera: "Pas de caméra sur cet appareil",
      errorNoHTTPS: "Contexte sécurisé requis (HTTPS, localhost)",
      errorAlreadyInUse: "La caméra est-elle déjà utilisée ?",
      errorNotSuitable: "Les caméras installées ne conviennent pas",
      errorNotSupported: "L'API de flux n'est pas prise en charge dans ce navigateur",
    },
    months: {
      january: "Janvier",
      february: "Février",
      march: "Mars",
      april: "Avril",
      may: "Peut",
      june: "Juin",
      july: "Juillet",
      august: "Août",
      september: "Septembre",
      october: "Octobre",
      november: "Novembre",
      december: "Décembre",
    },
    serverError: "Erreur du serveur",
  },

  dataFooter: {
    itemsPerPageText: "Objets par page:",
    itemsPerPageAll: "Tout",
    nextPage: "Page suivante",
    prevPage: "Page précédente",
    firstPage: "Première page",
    lastPage: "Dernière page",
    pageText: "{0}-{1} sur {2}",
  },

  messages: {
    created: "établi",
    Created: "Établi",
    deleted: "supprimé",
    Deleted: "Supprimé",
    updated: "actualisé",
    Updated: "Actualisé",
    confirmTitle: "Êtes-vous sûr?",
    confirmText: "Vous êtes sur le point de supprimer {0}. Es-tu sur de vouloir continuer?",
    confirmTextHardDelete: "Vous êtes sur le point de SUPPRIMER HARD {0} ! Es-tu sur de vouloir continuer?",
    confirmTextRestore: "Restaurer {0} ?",
    cancelButtonText: "Annuler",
    confirmButtonText: "Oui, {0}",
    confirmDelete: "effacer",
    confirmResolveText: "Vous êtes sur le point de résoudre {0}. Es-tu sur de vouloir continuer?",
    confirmResolve: "résoudre ce cas",
    confirmCloseText: "Vous êtes sur le point de fermer {0}. Es-tu sur de vouloir continuer?",
    confirmClose: "clôturer ce dossier",
    errorTitle: "Oops!",
    errorMessage: "Quelque chose s'est mal passé avec la demande. {0}. Veuillez contacter Tracefy pour obtenir de l'aide.",
    successTitle: "Yay!",
    successMessage: "{0} a été {1} avec succès !"
  },

  Navigation: {
    home: "Maison",
    map: "Carte",
    information: "Informations",
    installDevices: "Installer des appareils",
    analytics: "Analytique",
    tags: "Mots clés",
    reports: "Rapports",
    businesses: "Entreprises",
    entities: "Entités",
    users: "Utilisateurs",
    devices: "Dispositifs",
    tokenManagement: "Jetons",
    subscriptions: "Abonnements",
    subscriptionManagement: "Gestion des abonnements",
    maintenancePlans: "Forfaits d'entretien",
    notifications: "Notifications d'application",
    missing: "Disparu",
    shop: "Boutique",
    maintenanceBanner: 'Maintenance planifiée de',
    endYearNotice: 'Vous souhaitez profiter de l\'offre de fin d\'année ?',
    clickHere: 'Cliquez ici!',
    until: 'jusqu\'à'
  },

  Dashboard: {
    user: "Bienvenue {0}",
    map: "Carte",
    installDevices: "Installer des appareils",
    analytics: "Analytique",
    tags: "Mots clés",
    reports: "Rapports",
    businesses: "Entreprises",
    entities: "Entités",
    users: "Utilisateurs",
    devices: "Dispositifs",
    tokenManagement: "Jetons d'API",
    subscriptions: "Abonnements",
    subscriptionManagement: "Gestion des abonnements",
    maintenancePlans: "Forfaits d'entretien",
    notifications: "Notifications d'application",
    information: "Informations",
    version: "Version",
    missing: "Disparu",
    shop: "Boutique",
    notice: {
      velofollies: 'Viendras-tu aussi chez nous les 20, 21 et 22 janvier'
    }
  },

  Map: {
    tools: {
      search: "Rechercher quelque chose",
      noData: "Aucune entité trouvée..",
      noResults: "Veuillez ajuster votre recherche !",
      showFleet: "Afficher la flotte"
    },
    sidebar: {
      reload: "Recharger",
      loadMore: "Charger plus",
      trips: {
        title: "Voyages",
        dayTotals: "Total ce jour :",
      },
      error: {
        noTrips: "Vous n'avez aucun voyage en ce moment.",
        noMarkers: "Une erreur s'est produite lors du chargement de vos trajets."
      },
      information: {
        title: "Informations",
        lastLocation: "Dernier lieu",
        noLastLocation: "Pas de dernier emplacement",
        lastActivity: "Dernière Activité",
        noLastActivity: "Aucune activité pour le moment",
        odoDistance: "ODO Distance",
        brand: "Marque",
        noBrand: "Aucune marque spécifiée",
        model: "Modèle",
        noModel: "Aucun modèle spécifié",
        powerUnit: "Unité de puissance",
        noPowerUnit: "Aucune unité d'alimentation spécifiée",
        vehicleType: "Type de véhicule",
        noVehicleType: "Aucun type de véhicule spécifié",
        imei: "IMEI",
        vendor: "Vendeur",
        business: "Entreprise",
        noVendor: "Non lié au fournisseur",
        notApplicable: "n / a",
      }
    }
  },

  InstallDevices: {
    title: "Installer des appareils",
    infoGuideNotice: 'Cette page a reçu une mise à jour, consultez le nouvel ajout ici',
    noticeBosch1: 'REMARQUE: Vérifiez auprès de ',
    noticeBosch2: ' moteurs du réseau électrique sont activés avec le logiciel Bosch.',
    noticeConsumerInfo: '*L\'adresse e-mail et le numéro de téléphone sont uniquement destinés à des fins administratives (nous n\'envoyons pas d\'e-mails d\'activation aux clients)',
    form: {
      buttons: {
        install: "Installer",
        replace: "Remplacer",
        useQRScanner: "Utilisez l'appareil photo pour scanner QR",
        importPreset: "Préréglage d'importation",
        savePreset: "Préréglage d'importation automatique la prochaine fois",
        createNewPreset: "Créer un nouveau préréglage",
        managePresets: "Créer ou modifier un préréglage",
        editPreset: "Modifier le préréglage existant",
        deletePreset: "Supprimer le préréglage",
        createPreset: "Créer un préréglage",
        nextStep: "L'étape suivante",
        import: "Importer",
        createTags: "Créer des balises",
        information: "Guide et informations",
        returnForm: "Formulaire de retour"
      },
      types: {
        eBike: "vélo électrique",
        eCargoBike: "vélo cargo",
        speedPedelec: "vitesse pedelec",
        eMoped: "e-cyclomoteur",
        moped: "vélomoteur",
        automobile: "voiture",
        other: "autre",
      },
      tabs: {
        create: "Installer l'appareil",
        replace: "Remplacer l'appareil",
      },
      title: {
        create: "Créer une nouvelle entité",
        replace: "Remplacer l'entité",
        managePreset: "Gérer vos préréglages de formulaire",
      },
      panelHeaders: {
        target: "Utilisateur",
        device: "Dispositif",
        vehicleData: "Données du véhicule",
        details: "Détails",
      },
      subTitles: {
        selectPlan: "Sélectionnez le plan d'entretien",
        noPlansAvailable: "Aucun plan de maintenance trouvé",
        selectTags: "Sélectionnez les balises",
      },
      radio: {
        Customer: "Pour le client",
        CustomerTooltip: "Le client est facturable",
        OwnUse: "Pour son propre usage",
        OwnUseTooltip: "Vous êtes facturable",
      },
      placeholders: {
        presetName: "Nom du préréglage",
        name: "Nom de l'entité",
        frameNumber: "Numéro de cadre",
        imei: "Commencez à taper IMEI...",
        maintenancePlans: "Programmes d'entretien",
        odo: "Odo en kilomètres",
        other: "Autre",
        brand: "Marque",
        type: "Type de véhicule",
        powerunit: "Unité de puissance",
        engine: "Moteur",
        engineBrand: "Marque du moteur",
        engineType: "Type de moteur",
        model: "Modèle",
        tagGroups: "Balise prédéfinie (groupe)",
        licensePlate: "Plaque d'immatriculation",
        color: "Couleur",
        firstNameCustomer: 'Prénom du client',
        lastNameCustomer: 'Nom du client',
        customerEmail: "Email client",
        customerPhone: "Numéro de téléphone du client",
        extraTag: "Ajouter une balise supplémentaire",
        preset: "Sélectionnez le préréglage",
      },
      imei: {
        search: "Recherchez le numéro IMEI.",
        searching: "Recherche, veuillez patienter",
        notFound: "Aucun appareil trouvé",
        needNumbers: "Continuez à taper, nous avons besoin de {0} numéro supplémentaire{1}",
        tip: "Astuce : Soyez rapide et sécurisé en tapant les 6 derniers chiffres",
        huyserImei: 'Attention! Cet appareil est destiné à un vélo Huyser'
      },
      validation: {
        name: {
          required: "Le nom est requis",
          length: "Le nom est composé d'au moins 4 caractères",
        },
        odo: {},
        device: {
          required: "Le numéro IMEI est requis",
        },
        frameNumber: {
          required: "Le numéro de cadre est requis",
          length: "Le numéro de cadre se compose d'au moins 4 caractères",
        },
        licensePlate: {
          required: "La plaque d'immatriculation est obligatoire",
          length: "La plaque d'immatriculation se compose d'au moins 4 caractères",
        },
        customerInfoRequired: "Les informations client sont requises",
        customerEmail: {
          valid: "S'il vous plaît, mettez une adresse email valide",
        }
      },
      messages: {
        fillAllFields: "Remplissez tous les champs.",
        errorFromServer: "Erreur du serveur",
        success: "Entité créée",
        typeBrandAreRequired: "Les balises de type et de marque sont requises",
      },
      licensePlate: "Plaque d'immatriculation",
      metrics: "Métrique",
      device: "Dispositif",
      groups: "Groupes",
      tags: "Mots clés",
      actions: {
        create: "Créer {0}",
        replace: "Remplacer {0}",
        save: "Enregistrer {0}",
        cancel: "Annuler",
        search: "Recherchez un appareil IMEI.",
      }
    },

    listTitle: "20 dernières entités créées",
    noData: "Aucune entité trouvée !",
    noEntitiesTitle: "Aucune entité pour le moment !",
    noEntitiesSubtitle: "Créez votre première entité maintenant.",

    tooltips: {
      mapLocation: "Afficher l'emplacement sur la carte",
      status: "Statut",
      delete: "Effacer",
    }
  },

  ImeiStatus: {
    tab: 'Statut',
    serviceStatus: 'État du service',
    serviceStatuses: {
      connecting: 'De liaison',
      connected: 'Lié',
      live: 'Vivre'
    },
    consentDialog: {
      title: 'Avez-vous le consentement du client?',
      text: 'Cette action nécessite de visualiser l\'emplacement et les voyages récents de cette entité. Si nécessaire, un e-mail sera envoyé au client l\'informant que l\'emplacement est partagé.',
      confirm: 'Oui, j\'ai le consentement',
      cancel: 'Non, revenir'
    },
    headers: {
      entityInfo: 'Informations sur le véhicule',
      liveUpdates: 'Mises à jour du suivi en direct'
    },
    liveUpdates: {
      connectionError: 'Impossible de se connecter au service en direct',
      lastUpdate: 'Dernière mise à jour',
      currentSpeed: 'La rapidité',
      heading: 'Titre',
      network: 'Réseau',
      GPS: 'GPS',
      externalBattery: 'Batterie externe',
      connectedWaitingForUpdates: 'En attente des mises à jour du tracker...',
      noPastLocations: 'Attention ! Ce tracker n\'a pas de localisation historique ! Il n\'est probablement pas connecté correctement !',
      makeSureBikeOutside: 'Assurez-vous que le véhicule est à l\'extérieur, allumé et a déménagé récemment.',
      noUpdateNotice: 'S\'il n\'affiche pas de mise à jour après 5 minutes, le tracker est probablement mal connecté ou défectueux.'
    },
    map: {
      connectingToService: 'Connexion au service de mises à jour en direct...',
      customerEntityNotice: 'Impossible d\'afficher les informations de localisation, car un client est associé à ce véhicule'
    },
    tooltips: {
      requestLocationUpdate: 'Demander une mise à jour de l\'emplacement',
      mapLocation: 'Afficher l\'emplacement sur la carte',
      openInDebugView: 'Vérifier le tracker dans la page de débogage',
      lastWaypointsStrongGps: 'Ce tracker avait un signal GPS fort dans les 10 derniers waypoints',
      lastWaypointsMediumGps: 'Cet appareil avait un signal GPS médiocre dans les 10 derniers waypoints',
      lastWaypointsWeakGps: 'Cet appareil n\'a pas eu de signal GPS dans les 10 derniers waypoints',
      recentlyOnline: 'Ce tracker a été en ligne au cours des dernières 24 heures',
      notRecentlyOnline: 'Ce traceur est hors ligne depuis 24 heures',
      externalBatteryConnected: 'La batterie externe est connectée',
      externalBatteryDisconnected: 'La batterie externe est déconnectée',
      strongGps: 'Signal GPS fort',
      mediumGps: 'Signal GPS moyen',
      weakGps: 'Signal GPS faible',
      networkConnected: 'Réseau connecté',
      networkDisconnected: 'Aucune mise à jour pendant plus de 3 minutes'
    },
    noTripsToday: 'Aucun trajet trouvé aujourd\'hui.'
  },

  Reports: {
    title: "Rapports",
    periodic: {
      title: "Aperçu périodique",
      target: "Groupe ciblé",
      request: "Demander un rapport par courrier (CSV)",
      requestDone: "Rapport envoyé avec succès. Vous recevrez par email dans les plus brefs délais.",
      requestFail: "Une erreur s'est produite lors de la demande de votre rapport. Veuillez réessayer.",
      error: "Ce groupe cible comporte trop d'entités. Veuillez en sélectionner un avec moins.",
    },
    multiple: {
      all: "Multiples (Tous)",
      summary: "Multiple (Résumé)",
    },
    individual: "Aperçu individuel",
    period: "Période",
    date: "Date",
    toolbar: {
      selectEntity: "Sélectionnez une entité",
      selectUser: "Sélectionnez un utilisateur",
      selectDates: "Sélectionnez des dates",
    },
    notice: {
      title: "Voyages manquants ?",
      tooltip: "Au cours de la période sélectionnée, nous avons rencontré des problèmes potentiels",
    },

    table: {
      headers: {
        startTime: "Heure de début",
        startAddress: "Adresse de départ",
        stopTime: "Temps d'arrêt",
        stopAddress: "Adresse d'arrêt",
        distance: "Distance",
        duration: "Durée",
        averageSpeed: "Vitesse moyenne",
        idle: "Temps sur place",
        id: "IDENTIFIANT",
        vendor: "Vendeur",
        odo: "Odon",
        lastSeen: "Vu pour la dernière fois",
        tags: "Mots clés",
        name: "Nom",
      },
      noDataText: {
        all: "Veuillez spécifier votre plage de dates et sélectionner une entité ou un utilisateur pour continuer.",
        date: "Veuillez spécifier votre plage de dates pour continuer.",
        user: "Veuillez sélectionner un utilisateur.",
        searched: "Aucun résultat trouvé... Veuillez ajuster vos critères.",
        clickSearch: "Cliquez sur rechercher pour continuer.",
      }
    }
  },

  Analytics: {
    title: "Analytique",
    chart: {
      from: "De",
      till: "Jusqu'à",
      total: "Véhicules totaux",
      noData: {
        title: "Pas de données disponibles",
        body: "Il n'y a pas de données pour les paramètres fournis.",
      },
      loading: "Veuillez patienter pendant que nous chargeons les données...",
      error: "Erreur lors du chargement de vos données",
    },
    toolbar: {
      addChart: "Ajouter un graphique",
      addChartTip: "Générez un graphique avec le bouton + à droite pour afficher un graphique ici.",
    },
    tooltips: {
      addChart: "Ajouter un nouveau graphique",
    },
    ranges: {
      pastWeek: "La semaine dernière",
      pastMonth: "Mois passé",
      custom: "Douane",
    },
    dialog: {
      title: "Ajouter un nouveau graphique",
      fields: {
        preset: "Choisissez un préréglage",
        targetGroup: "Groupe cible (facultatif)",
        period: "Période sélectionnée",
      },
      actions: {
        create: "Ajouter un graphique",
        save: "sauvegarder",
        cancel: "Annuler",
      }
    }
  },

  Businesses: {
    tooltips: {
      edit: "Modifier {0}",
      delete: "Supprimer {0}",
    },
    statistics: {
      availableDevices: "Appareils disponibles :",
      totalSubscriptions: "Abonnements totaux :",
    },
    toolbar: {
      search: "Rechercher des entreprises",
      noVendor: "Sélectionnez un fournisseur",
      options: "Plus d'options",
      createBusiness: 'Créer une entreprise',
      editBusiness: "Modifier {0}",
      deleteBusiness: "Supprimer {0}",
      createUser: "Créer un utilisateur",
      linkToBusiness: "Lier les entités à l'entreprise",
    },
    treeView: {
      noVendors: "Aucun fournisseur trouvé"
    },
    form: {
      name: "Nom",
      address: "Adresse",
      postcode: "Code postal",
      city: "Ville",
      country: "Pays",
      email: "E-mail",
      phone: "Téléphoner",
      businessPropertiesTitle: "Propriétés d'entreprise spécifiques au super-administrateur :",
      parentBusiness: "Entreprise mère",
      createRootBusiness: "Créer une entreprise racine",
      nameUpper: "Nom et numéro de cadre en majuscules",
      hasCustomers: "A des clients (concessionnaire)",
      canInstallDevices: "Peut installer des appareils",
      recoveryContract: "Contrat de récupération",
    },
    dialog: {
      linkEntitiesToUser: "Lier des entités à un utilisateur",
      deleteBusiness: "Supprimer l'entreprise",
      createUserForVendor: "Créer un utilisateur pour le fournisseur",
      createBusiness: "Créer une entreprise",
      editBusiness: "Modifier l'entreprise",
      linkToBusiness: "Lier les entités à l'entreprise",
      selectBusiness: "Sélectionnez une entreprise",
      delete: {
        deleteUser: "Supprimer l'utilisateur",
        areYouSure: "Voulez-vous vraiment supprimer cet utilisateur ?",
        userDeleted: "Utilisateur supprimé avec succès.",
        error: "Une erreur s'est produite lors de la suppression de cet utilisateur. Veuillez réessayer.",
      },
      update: {
        success: "Utilisateur mis à jour avec succès",
        error: "Une erreur s'est produite lors de la mise à jour de cet utilisateur. Veuillez réessayer",
      },

      fields: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        address: "Adresse",
        postcode: "Code postal",
        city: "Ville",
        phone: "Téléphoner",
        email: "E-mail",
        role: "Rôle d'utilisateur",
        vendor: "Vendeur",
        password: "Mot de passe temporaire",
      }
    },
    devicesTab: {
      title: "Dispositifs",
      search: "Rechercher des appareils",
      subtitle: "Appareils pour {0}",
      headers: {
        name: "Nom",
        imei: "IMEI",
        entityName: "Nom de l'entité",
        business: "Entreprise",
        lastSeen: "Vu pour la dernière fois",
        createdAt: "Créé à",
        location: "Emplacement",
      }
    },
    entitiesTab: {
      title: "Entités",
      search: "Entités de recherche",
      subtitle: "Entités pour {0}",
      headers: {
        name: "Nom",
        frameNumber: "Numéro de cadre",
        deviceImei: "Appareil IMEI",
        business: "Entreprise",
        userName: "Nom du consommateur",
        lastSeen: "Vu pour la dernière fois",
        createdAt: "Créé à",
        subscription: "Abonnement",
        linkTo: "Actions",
      }
    },
    usersTab: {
      title: "Utilisateurs",
      search: "Rechercher des utilisateurs",
      subtitle: "Utilisateurs pour {0}",
      headers: {
        name: "Nom",
        firstName: "Prénom",
        lastName: "Nom de famille",
        email: "E-mail",
        role: "Rôle",
        business: "Entreprise",
        lastSeen: "Vu pour la dernière fois",
        createdAt: "Créé à",
        updatedAt: "Mis à jour à",
        actions: "Actions",
      }
    },

    dialogs: {
      actions: {
        create: "Créer {0}",
        save: "Enregistrer {0}",
        cancel: "Annuler",
      },
      linkUser: {
        title: "Lier des entités à un utilisateur",
        fields: {
          select: "Sélectionnez l'utilisateur",
        }
      },
      linkVendor: {
        title: "Associer des articles à un fournisseur",
        fields: {
          select: "Sélectionnez le fournisseur"
        }
      },
      createUser: {
        title: "Créer un utilisateur pour le fournisseur",
        fields: {
          firstName: "Prénom",
          lastName: "Nom de famille",
          address: "Adresse",
          postcode: "Code postal",
          city: "Ville",
          phone: "Téléphoner",
          email: "E-mail",
          userRole: "Rôle d'utilisateur",
          vendor: "Vendeur",
          password: "Mot de passe temporaire",
          passwordHint: "Double-cliquez sur le champ pour un nouveau mot de passe aléatoire",
        }
      }
    }
  },

  UserManagement: {
    model: {
      titleCase: {
        single: "Utilisateur",
        plural: "Utilisateurs",
      },
      lowerCase: {
        single: "utilisateur",
        plural: "utilisateurs",
      }
    },
    tooltips: {
      edit: "Modifier {0}",
      delete: "Supprimer {0}",
      tokens: "Jetons",
      showEntities: "Afficher les entités utilisateur",
      goToSubscriptions: "À l'abonnement de {0}"
    },
    toolbar: {
      search: "Chercher",
    },
    table: {
      buttons: {},
      headers: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        address: "Adresse",
        postcode: "Code postal",
        city: "Ville",
        phone: "Téléphoner",
        telephone: "Téléphone",
        email: "Adresse e-mail",
        business: "Entreprise",
        role: "Rôle",
        lastSeen: "Vu pour la dernière fois",
        actions: "Actions",
      }
    },
    dialog: {
      title: {
        create: "Nouvel utilisateur",
        edit: "Modifier l'utilisateur",
        editAccount: "Modifier le compte",
      },
      fields: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        address: "Adresse",
        postcode: "Code postal",
        city: "Ville",
        phone: "Téléphoner",
        telephone: "Téléphone",
        email: "E-mail",
        userRole: "Rôle d'utilisateur",
        role: "Rôle d'utilisateur",
        business: "Entreprise",
        password: "Mot de passe temporaire",
        passwordHint: "Double-cliquez sur le champ pour un nouveau mot de passe aléatoire",
        changePassword: "Changer le mot de passe",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        newPasswordConfirmation: "Confirmation du nouveau mot de passe",
      },
      actions: {
        create: "Créer un utilisateur",
        save: "Enregistrer l'utilisateur",
        cancel: "Annuler",
        hardDelete: "Supprimer FORT {0}",
        restore: "restaurer {0}",
      }
    }
  },

  EntityManagement: {
    model: {
      titleCase: {
        single: "Entité",
        plural: "Entités",
      },
      lowerCase: {
        single: "entité",
        plural: "entités",
      }
    },
    snackbar: {
      requiredFields: "Le nom, la marque et la couleur sont obligatoires"
    },
    stepper: {
      add: "Ajouter des balises aux entités",
      addTags: "Sélectionnez les balises",
      overview: "Aperçu",
      continue: "Continuer",
      save: "Soumettre",
      back: "Retour",
      cancel: "Annuler",
      confirm: "Vous êtes sur le point d'attacher les balises suivantes à {0} {1}. Êtes-vous sûr?",
    },
    missing: {
      confirm: "Vous êtes sur le point de déclarer un total de {0} {1}. Êtes-vous sûr?",
      report: "Signaler une entité manquante",
      modalTitle: "Êtes-vous sûr?",
      modalText: "Êtes-vous sûr de vouloir signaler ce véhicule comme manquant au service de récupération ?",
      uninsuredEntitiesWarning: "Les entités suivantes n'ont pas d'abonnement et ne peuvent pas être signalées comme manquantes.",
      continue: "Souhaitez-vous continuer?",
      tryAgain: "Veuillez essayer une autre entité ou vous inscrire pour un abonnement.",
      reportedMissing: "Porté disparu!",
    },
    csvModal: {
      title: 'Recevoir les données du tableau au format CSV par e-mail?',
      text: 'Dans quelques minutes, le CSV sera envoyé à votre adresse e-mail d\'utilisateur.'
    },
    tooltips: {
      isCustomer: 'Entité client',
      ownEntity: 'Propre entité',
      csv: "Demander des données de table par CSV",
      create: "Créer une nouvelle entité",
      tags: "Ajouter des balises",
      missing: "Signaler une entité manquante",
      missingDisabled: "Service de récupération désactivé, intéressé par ce service ? Veuillez contacter l'assistance",
      deleteDisabled: "Ne peut pas être supprimé car cette entité a un client",
      showAsQr: "Afficher IMEI comme code QR"
    },
    noOdo: 'n/a',
    toolbar: {
      title: {
        filtered: "Affichage de {0} entités sur {1}",
      },
      search: "Chercher",
    },
    table: {
      buttons: {
        edit: "Modifier {0}",
        view: 'Regarder {0}',
        delete: "Supprimer {0}",
      },
      headers: {
        name: "Nom de l'entité",
        frameNumber: "Numéro de cadre",
        subscription: "Abonnement",
        deviceImei: "Appareil IMEI",
        odo: "ODO distance",
        vendor: "Vendeur",
        targetGroup: "Groupe ciblé",
        lastSeen: "Vu pour la dernière fois",
        tags: "Mots clés",
        createdAt: "Créé à",
        createdBy: "Créé par",
        actions: "Actions",
      }
    },
    dialog: {
      unregisteredEntityHelper: "Pour modifier une entité non enregistrée, veuillez la supprimer et en créer une nouvelle en utilisant la fonctionnalité 'Installer des appareils'.",
      title: {
        create: "Nouvelle entité",
        edit: "Modifier l'entité",
        details: "informations sur l'entité",
        tags: "Sélectionnez les balises",
      },
      fields: {
        name: "Nom",
        imei: "IMEI",
        frameNumber: "Numéro de cadre",
        deviceImei: "Appareil IMEI",
        vendor: "Vendeur",
        targetGroup: "Groupe ciblé",
        odo: "ODO",
        metrics: "Métrique",
      },
      actions: {
        create: "Créer une entité",
        save: "Enregistrer l'entité",
        cancel: "Annuler",
      }
    }
  },

  MaintenancePlans: {
    title: 'Forfaits d\'entretien',
    general: {
      allAssignedEntites: "Toutes les entités affectées à ce plan",
      createNewTrigger: "Créer un nouveau déclencheur",
      selectTrigger: "Sélectionnez un déclencheur existant",
      mustHaveTitle: "Le plan doit avoir un titre",
      mustHaveDescription: "Le plan doit avoir une description",
      maxLength: "La longueur maximale de la description est de 250 caractères.",
      name: "Nom",
      frameNumber: "Numéro de cadre",
      tags: "Mots clés",
      vendor: "Vendeur",
      value: "Évaluer",
      metric: "Métrique",
      description: "La description",
      actions: "Actions",
      allEntities: "Toutes les entités",
      searchEntities: "Chercher",
      searchTriggers: "Déclencheurs de recherche",
      notifications: "Avis",
      notDeleted: "Non supprimé",
      pfew: "Ouf, c'était proche !",
      notConfirmed: "Pas confirmé",
      confirmOrDismiss: "Vous devez confirmer ou rejeter ce message pour supprimer l'élément.",
      planDeleted: "Forfait supprimé",
      wasDeleted: "Le plan a été supprimé avec succès.",
      deleteFailed: "Échec de la suppression",
      planNotDeleted: "Le plan n'a pas été supprimé",
      getPlanFailed: "Une erreur s'est produite",
      wrongGettingPlan: "Une erreur s'est produite lors de l'obtention du plan. Veuillez contacter Tracefy pour obtenir de l'aide.",
      failed: "Manqué",
      failedGettingTriggers: "Échec de l'obtention des déclencheurs de ce plan. Veuillez contacter Tracefy pour obtenir de l'aide.",
      failedGettingPlanEntities: "Échec de l'obtention de ces entités de plans. Veuillez contacter Tracefy pour obtenir de l'aide.",
      failedRemovePlan: "Échec de la suppression de l'entité du plan",
      wrongActivatingPlan: "Une erreur s'est produite lors de l'activation du plan",
      deletePlan: "Supprimer le forfait",
      areYouSure: "Êtes-vous sûr de bien vouloir supprimer cet élément",
    },
    toasts: {
      planned: "Avis prévu",
      completed: "Notification marquée comme terminée",
      open: "Notification marquée comme ouverte",
      archived: "Notification archivée",
      userAssigned: "Utilisateur affecté",
      userUnassigned: "Utilisateur non attribué",
    },
    tooltips: {
      createPlan: "Créer un plan d'entretien",
      editPlan: "Modifier {0}",
      deletePlan: "Supprimer {0}",
      openPlan: "Afficher {0} détails",
      activatePlan: "Activer {0}",
      deactivatePlan: "Désactiver {0}",
      assignUser: "Attribuer un utilisateur",
      addDate: "Ajouter une date",
      changeDate: "Date de modification",
      completeNotification: "Notification complète",
      archiveNotification: "Avis d'archivage",
      showDetails: "Afficher les détails",
      hideDetails: "Cacher les détails",
    },
    notification: {
      noOdo: "Entité odo introuvable",
      noTrigger: "Aucun déclencheur attribué",
      noTriggerValue: "Pas de valeur de déclenchement",
      noUser: "Aucun utilisateur affecté",
      noEntity: "Aucune entité attribuée",
    },
    toolbar: {
      searchText: "Chercher",
      filterText: "Filtre",
      sortByText: "Trier par",
      plans: {
        sortOptions: {
          name: "Nom",
          createdAt: "Créé à",
        },
        filterOptions: {
          activated: "Activé",
          deactivated: "Désactivé",
        }
      },
      notifications: {
        sortOptions: {
          entityName: "Nom de l'entité",
          userName: "Nom d'utilisateur attribué",
          tiggerName: "Nom du déclencheur",
          createdAt: "Créé à",
          plannedAt: "Date prévue",
        },
        filterOptions: {
          open: "Ouvert",
          done: "Fait",
          archived: "Archivé",
        }
      }
    },
    planTabs: {
      info: {
        title: "Informations",
      },
      triggers: {
        title: "Déclencheurs",
        headers: {
          name: "Nom",
          value: "Évaluer",
          metric: "Métrique",
          actions: "Actions",
        }
      },
      entities: {
        title: "Entités",
        headers: {
          name: "Nom",
          tags: "Mots clés",
          vendor: "Vendeur",
          actions: "Actions",
        }
      }
    },
    save: "sauvegarder",
    close: "proche",
    switchLabel: "Actif",
    planDialog: {
      validationRules: {
        required: "Le plan doit avoir un {0}",
        maxLength: "La longueur maximale du {0} est de {1} caractères.",
      },
      title: "Modifier le plan d'entretien",
      save: "sauvegarder",
      close: "proche",
      createTrigger: "Créer un nouveau déclencheur",
      selectTrigger: "Sélectionnez un déclencheur existant",
      searchTextTrigger: "Déclencheurs de recherche",
      searchTextEntity: "Entités de recherche",
      create: "Créer un plan d'entretien",
      edit: "Modifier le plan d'entretien",
      description: "La description",
      active: "Actif",

      stepOne: {
        title: "Détails du forfait",
        subtitle: "Modifier le titre et la description",
        titleText: "Titre",
        descriptionTitle: "La description",
      },
      stepTwo: {
        title: "Entités",
        subtitle: "Ajouter ou supprimer des entités pour ce plan",
        allEntities: "Toutes les entités",
        searchText: "Entités de recherche",
        headers: {
          name: "Nom",
          frameNumber: "Numéro de cadre",
          tags: "Mots clés",
          vendor: "Vendeur",
        }
      },
      stepThree: {
        title: "Déclencheurs",
        subtitle: "Ajouter ou supprimer des déclencheurs pour ce plan",
        searchText: "Déclencheurs de recherche",
        headers: {
          name: "Nom",
          value: "Évaluer",
          metric: "Métrique",
          description: "La description",
          actions: "Actions",
        }
      }
    },
    noPlans: "Pas encore de plans de maintenance !",
    noPlanSearchResult: "Aucun plan de maintenance pour les critères !",
    noNotifications: "Pas encore de notifications !",
    noNotificationSearchResult: "Aucune notification pour les critères !",
  },

  DeviceManagement: {
    model: {
      titleCase: {
        single: "Dispositif",
        plural: "dispositifs",
      },
      lowerCase: {
        single: "dispositif",
        plural: "Dispositifs",
      }
    },
    tooltips: {
      edit: "Modifier {0}",
      delete: "Supprimer {0}",
    },
    toolbar: {
      title: {
        filtered: "Affichage de {0} appareils sur {1}",
        total: "Total",
      },
      search: "Chercher",
      selected: "Sélectionné : {0} appareils",
      scan: "IMEI",
    },
    table: {
      buttons: {},
      headers: {
        index: "Indice",
        title: "Dispositif",
        description: "La description",
        imei: "IMEI",
        iccid: "ICCID",
        model: "Modèle",
        firmwareVersion: "Version du firmware",
        settingsCrc: "Paramètres CRC",
        entityName: "Nom de l'entité",
        subVendorName: "Vendeur",
        lastSeen: "Vu pour la dernière fois",
        createdAt: "Créé à",
        actions: "Actions",
      }
    },
    dialog: {
      title: {
        create: "Nouvel appareil",
        edit: "Modifier l'appareil",
        linkDevicesDialog: "Relier les appareils à l'entreprise",
        scanDevicesDialog: "Analyser les appareils",
      },
      fields: {
        title: "Titre",
        description: "La description",
        imei: "Imei",
        model: "Modèle",
        firmwareVersion: "Version du firmware",
        settingsCrc: "Paramètres CRC",
        iccid: "ICCID",
        vendor: "Entreprise",
        lastSeen: "Vu pour la dernière fois",
        createdAt: "Créé à",
      },
      actions: {
        create: "Créer un appareil",
        save: "sauvegarder",
        cancel: "Annuler",
        exportAndSave: "Exporter et enregistrer",
      }
    },
    input: {
      placeholder: "Sélectionnez l'entreprise",
    },
    sweetAlert: {
      title: "Échec de l'association de {0} appareils !",
    }
  },

  Information: {
    intro: {
      text: '',
      link: "Vous cherchez notre documentation API ?",
    },

    tabs: {
      installation: "Guides d'installation",
      portal: "Guides du portail",
      app: "Guides d'applications",
      marketing: "Contenu marketing",
    },
    videos: "Vidéos",
    documents: "Documents",
    images: "Images",
  },

  Missing: {
    title: "Entités manquantes",
    messages: {
      noCases: "Il n'y a pas (encore) de cas.",
      locating: {
        success: "Bluetooth activé pendant 10 minutes",
        failed: "Il y a eu un problème lors de l'activation du Bluetooth, veuillez réessayer.",
      },
      resolved: "Cas marqué comme résolu avec succès.",
      closed: "Dossier marqué comme clôturé avec succès.",
    },
    tooltips: {
      locate: "Localisez l'appareil via Bluetooth",
      close: "Impossible de localiser l'entité ? Fermez ce dossier.",
      resolve: "Entité localisée et récupérée ? Résolvez cette affaire.",
    },
    dialogs: {
      close: "Êtes-vous sûr de vouloir clore ce litige ?",
    }
  },

  Notifications: {
    createNotification: "Créer une notification",
    editNotification: "Modifier la notification",
    lastSentNotifications: "Dernières notifications envoyées",
    confirmDeleteMessage: "Voulez-vous vraiment supprimer cette notification planifiée ?",
    scheduleNotification: "Notification de planification",
    updateNotification: "Avis de mise à jour",
    deleteNotification: "Supprimer cette notification planifiée",
    plannedNotifications: "Notifications planifiées",
    validationFailedMessage: "La date, l'heure, le titre et le message sont obligatoires !",
    allUsers: "Tous les consommateurs",
    recipients: "Destinataires",
    selectDate: "Sélectionner une date",
    selectTime: "Sélectionnez l'heure",
    title: "Titre",
    body: "tapez votre message ici",
  },

  Shop: {
    addedToCart: "Ajouté au panier !",
  },

  AppBar: {
    changeLanguage: "Changer de langue",
    toggleNightmode: "Basculer en mode nuit",
    toggleChristmas: "Basculer Noël",
    logout: "Se déconnecter",
  },

  Support: {
    emailUs: 'Envoyez-nous un courriel',
    callOrApp: "Appelez-nous ou appliquez-nous",
    weekdays: "lu-ven",
  },
  Snackbar: {
    success: "Succès!",
    generalError: "Action: échoué!",
  }
}
